import { Table } from '@components/shared/Table'

import { parseConsolidatedSummaryGrid } from './helpers/parseConsolidatedSummaryGrid'

import type { ConsolidatedSummaryTableProps } from './types'

export const ConsolidatedSummaryTable = ({ rows, isLoading }: ConsolidatedSummaryTableProps) => {
  const { data, totalData, groupedHeaderRow } = parseConsolidatedSummaryGrid(rows)

  return <Table data={data} totalData={totalData} groupedHeaderRow={groupedHeaderRow} isLoading={isLoading} />
}
